import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class LocationAddress extends AbstractModel {
  @autoserialize
  stateCode: string;

  @autoserialize
  streetAddress1: string;

  @autoserialize
  streetAddress2: string;

  @autoserialize
  city: string;

  @autoserialize
  zipCode: string;

  @autoserialize
  county: string;

  get displayAddress(): string {
    return this.streetAddress1 + ' ' + this.city + ', ' + this.stateCode + ' ' + this.zipCode;
  }

  equals(address: LocationAddress): boolean {
    return (
      this.streetAddress1 === address.streetAddress1 &&
      this.streetAddress2 === address.streetAddress2 &&
      this.city === address.city &&
      this.stateCode === address.stateCode &&
      this.zipCode === address.zipCode &&
      this.county === address.county
    );
  }
}
